import { NewsletterPopup } from "@/api/generated/BMWInterfaces"

// Newsletter copy and trigger config (DLK-492).
//
// Only the heading/subtitle (both placements) and the popup image come from the CMS, via
// GET api/appMetaData/getNewsletter. Everything below is static per the 20.07.2026 decision
// that removed button text, legal text, error/thank-you copy, screen selection, trigger delay
// and display frequency from CMS scope.

// Footer-strip defaults. The strip is always rendered on every page; when the CMS returns
// empty strings these approved Figma strings are used instead (never hide the strip).
export const NEWSLETTER_HEADING = "תהיו הראשונים לדעת"
export const NEWSLETTER_SUBTITLE = "הירשמו ותקבלו עדכונים על דגמים חדשים, אירועים ומחירים מיוחדים"

export const NEWSLETTER_EMAIL_PLACEHOLDER = "*דוא״ל"
export const NEWSLETTER_SUBMIT_LABEL = "להרשמה"

export const NEWSLETTER_LEGAL_PREFIX =
  "הזנת הפרטים מהווה הסכמה לקבל מקבוצת דלק מוטורס דיוורים, עדכונים, מבצעים, אירועים והטבות מטעם המותג DIRECT באמצעי התקשרות אותם הזנת. הפרטים יישמרו במאגר המידע ויעשה בהם שימוש בהתאם לתנאי "
export const NEWSLETTER_LEGAL_LINK_TEXT = "מדיניות הפרטיות"
export const NEWSLETTER_LEGAL_SUFFIX = " של הקבוצה"
export const NEWSLETTER_PRIVACY_URL =
  "https://www.delek-motors.co.il/%d7%9e%d7%93%d7%99%d7%a0%d7%99%d7%95%d7%aa-%d7%a4%d7%a8%d7%98%d7%99%d7%95%d7%aa/"

// Validation + submission messages (Hebrew).
export const NEWSLETTER_EMAIL_ERROR = "יש להזין כתובת דוא״ל תקנית"
export const NEWSLETTER_GENERAL_ERROR = "אירעה שגיאה, אנא נסו שוב מאוחר יותר"
export const NEWSLETTER_DUPLICATE_ERROR = "כתובת הדוא״ל כבר רשומה לרשימת התפוצה"

// Footer-strip success (thank-you) state — static, verified against Figma 2149:70093.
export const NEWSLETTER_THANK_YOU_HEADING = "תודה - נרשמת בהצלחה!"

// Popup image is a single CMS asset used at both breakpoints.
export const NEWSLETTER_POPUP_IMAGE_WIDTH = 1018
export const NEWSLETTER_POPUP_IMAGE_HEIGHT = 366
export const NEWSLETTER_POPUP_IMAGE_ALT = "DIRECT newsletter"

// Distinct API source values per placement, sent as `formName` (DLK-492 source identification).
export const NEWSLETTER_SOURCE_FOOTER = "footer"
export const NEWSLETTER_SOURCE_ENTRY_POPUP = "entry popup"
export const NEWSLETTER_SOURCE_EXIT_POPUP = "exit popup"

// Popup trigger timing — hardcoded per 20.07.2026 (no CMS fields).
export const NEWSLETTER_ENTRY_DELAY_MS = 10_000 // mobile entry: 10s after load
export const NEWSLETTER_ENTRY_DELAY_DESKTOP_MS = 0 // desktop entry: on load (DLK-1027)
export const NEWSLETTER_EXIT_INACTIVITY_MS = 30_000 // mobile exit: 30s idle

// Cookie set on a successful registration from ANY placement, so the popup is never shown
// again. A cookie (not localStorage) is required by the ticket so it survives a storage clear.
export const NEWSLETTER_REGISTERED_COOKIE = "direct_newsletter_registered"
export const NEWSLETTER_REGISTERED_COOKIE_MAX_AGE = 60 * 60 * 24 * 365

// Frequency for non-registered users: once per day. Also a cookie rather than sessionStorage,
// since the window has to outlive the browser session.
export const NEWSLETTER_POPUP_SHOWN_COOKIE = "direct_newsletter_popup_shown"
export const NEWSLETTER_POPUP_SHOWN_COOKIE_MAX_AGE = 60 * 60 * 24

export interface ResolvedNewsletterPopup {
  title: string
  subtitle: string | null
  imageUrl: string
}

export const resolvePopup = (
  popup: NewsletterPopup | null | undefined,
): ResolvedNewsletterPopup | null => {
  const title = popup?.title?.trim()
  const imageUrl = popup?.imageUrl?.trim()
  if (!title || !imageUrl) return null
  return { title, subtitle: popup?.subtitle?.trim() || null, imageUrl }
}
